import Vue from "vue";

export default {
  async login(data) {
    return (await Vue.axios.post("login", data)).data;
  },

  async get() {
    const response = await Vue.axios.get("settings");
    return response.data;
  },

  async update(settings) {
    const response = await Vue.axios.post(`settings`, settings);
    return response;
  }
};
